module.exports = __webpack_public_path__ + "static/media/budget.593b2ad9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/budget.svg
// module id = 802
// module chunks = 0